module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.3dc654f4.ttf";